import { NgModule, ModuleWithProviders, APP_INITIALIZER , Optional, SkipSelf } from '@angular/core';
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { environment } from "../../environments/environment";
//import { IonicStorageModule } from "@ionic/storage";
import { IonicStorageModule } from "@ionic/storage-angular";
import { AkitaAuthGuard } from "./guards/akita-auth.guard";
import { AkitaAuthService } from "./services/akita-auth.service";
import { AkitaAuthQuery } from './store/auth/akita-auth.query';
import { AkitaAuthStore, AkitaAuthState } from './store/auth/akita-auth.store';
import { AuthenticationService } from "../cp/shared/services/authentication.service";

import {services} from '@app/core/services'
import { throwIfAlreadyLoaded } from './guards/module-import.guard';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    // HotkeysModule.forRoot(),

  ],
  exports: [],
  providers: [
      AkitaAuthGuard,
      AkitaAuthService,
      AkitaAuthQuery,
      AkitaAuthStore,
      AuthenticationService,

    ...services,

  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

}
